import { render, staticRenderFns } from "./CamaraRegistroPantalla.vue?vue&type=template&id=65836d6e&scoped=true&"
import script from "./CamaraRegistroPantalla.vue?vue&type=script&lang=ts&"
export * from "./CamaraRegistroPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65836d6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('65836d6e', component.options)
    } else {
      api.reload('65836d6e', component.options)
    }
    module.hot.accept("./CamaraRegistroPantalla.vue?vue&type=template&id=65836d6e&scoped=true&", function () {
      api.rerender('65836d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/Registro/CamaraRegistroPantalla.vue"
export default component.exports